import storeApi from '@/api/storeApi'

const SET_APP_LIST = 'setAppList'
const SET_APP_COUNT = 'setAppCount'
const SET_USER_APP_LIST = 'setUserAppList'
const SET_USER_APP_COUNT = 'setUserAppjount'
const SET_AGENT_APP_LIST = 'setAgentAppList'
const SET_AGENT_APP_COUNT = 'setAgentAppCount'
const SET_APP_EXTEND_PARAM_LIST = 'setExtendParamList'
const SET_APP_EXTEND_PARAM_COUNT = 'setExtendParamCount'
const SET_APP_CATEGORY_LIST = 'setAppCategoryList'
const SET_APP_CATEGORY_COUNT = 'setAppCategoryCount'

const state = {
  appList: [],
  appCount: 0,

  userAppList: [],
  userAppCount: 0,

  agentAppList: [],
  agentAppCount: 0,

  appExtendParamList: [],
  appExtendParamCount: 0,

  appCategoryList: [],
  appCategoryCount: 0
}

const mutations = {
  [SET_APP_LIST] (state, appList) {
    state.appList = appList
  },
  [SET_APP_COUNT] (state, appCount) {
    state.appCount = appCount
  },
  [SET_USER_APP_LIST] (state, userAppList) {
    state.userAppList = userAppList
  },
  [SET_USER_APP_COUNT] (state, userAppCount) {
    state.userAppCount = userAppCount
  },
  [SET_AGENT_APP_LIST] (state, agentAppList) {
    state.agentAppList = agentAppList
  },
  [SET_AGENT_APP_COUNT] (state, agentAppCount) {
    state.agentAppCount = agentAppCount
  },
  [SET_APP_EXTEND_PARAM_LIST] (state, appExtendParamList) {
    state.appExtendParamList = appExtendParamList
  },
  [SET_APP_EXTEND_PARAM_COUNT] (state, appExtendParamCount) {
    state.appExtendParamCount = appExtendParamCount
  },
  [SET_APP_CATEGORY_LIST] (state, appCategoryList) {
    state.appCategoryList = appCategoryList
  },
  [SET_APP_CATEGORY_COUNT] (state, appCategoryCount) {
    state.appCategoryCount = appCategoryCount
  }
}

const getters = {
  appListOptions: state => {
    const options = []
    state.appList.forEach(app => {
      const option = {
        label: app.app_name_i18n[0].name,
        value: app.app_store_id,
        children: [],
        packageIndex: -1
      }

      app.package.forEach(pac => {
        option.children.push({
          label: pac.name,
          value: pac
        })
      })
      options.push(option)
    })
    return options
  }
}

const actions = {
  async getApps ({ commit }, data) {
    try {
      const res = await storeApi.getApps(data)
      if (res && res.rcode === 0) {
        commit(SET_APP_LIST, res.result.data)
        commit(SET_APP_COUNT, res.result.count)
      }
      return res
    } catch (err) {
      return err
    }
  },
  async addApp ({ commit }, data) {
    try {
      return await storeApi.addApp(data)
    } catch (err) {
      return err
    }
  },
  async editApp ({ commit }, data) {
    try {
      return await storeApi.editApp(data)
    } catch (err) {
      return err
    }
  },
  async deleteApp ({ commit }, data) {
    try {
      return await storeApi.deleteApp(data)
    } catch (err) {
      return err
    }
  },

  // 用户应用
  async getUserApps ({ commit }, data) {
    try {
      const res = await storeApi.getUserApps(data)

      if (res && res.rcode === 0) {
        commit(SET_USER_APP_LIST, res.result.data)
        commit(SET_USER_APP_COUNT, res.result.count)
      }
      return res
    } catch (err) {
      console.log(err)
    }
  },
  async addUserApp ({ commit }, data) {
    try {
      return await storeApi.addUserApp(data)
    } catch (err) {
      return err
    }
  },
  async editUserApp ({ commit }, data) {
    try {
      return await storeApi.editUserApp(data)
    } catch (err) {
      return err
    }
  },
  async deleteUserApp ({ commit }, data) {
    try {
      return await storeApi.deleteUserApp(data)
    } catch (err) {
      return err
    }
  },

  // 代理商应用
  async getAgentApps ({ commit }, data) {
    try {
      const res = await storeApi.getAgentApps(data)

      if (res && res.rcode === 0) {
        commit(SET_AGENT_APP_LIST, res.result.data)
        commit(SET_AGENT_APP_COUNT, res.result.count)
      }
      return res
    } catch (err) {
      return err
    }
  },
  async addAgentApp ({ commit }, data) {
    try {
      return await storeApi.addAgentApp(data)
    } catch (err) {
      return err
    }
  },
  async editAgentApp ({ commit }, data) {
    try {
      return await storeApi.editAgentApp(data)
    } catch (err) {
      return err
    }
  },
  async deleteAgentApp ({ commit }, data) {
    try {
      return await storeApi.deleteAgentApp(data)
    } catch (err) {
      return err
    }
  },

  // 应用扩展字段
  async getAppExtendParams ({ commit }, data) {
    try {
      const res = await storeApi.getAppExtendParams(data)

      if (res && res.rcode === 0) {
        commit(SET_APP_EXTEND_PARAM_LIST, res.result.data)
        commit(SET_APP_EXTEND_PARAM_COUNT, res.result.count)
      }
      return res
    } catch (err) {
      console.log(err)
    }
  },
  async addAppExtendParam ({ commit }, data) {
    try {
      return await storeApi.addAppExtendParam(data)
    } catch (err) {
      return err
    }
  },
  async editAppExtendParam ({ commit }, data) {
    try {
      return await storeApi.editAppExtendParam(data)
    } catch (err) {
      return err
    }
  },
  async deleteAppExtendParam ({ commit }, data) {
    try {
      return await storeApi.deleteAppExtendParam(data)
    } catch (err) {
      return err
    }
  },

  // 应用标签分类
  async getAppCategories ({ commit }, data) {
    try {
      const res = await storeApi.getAppCategories(data)
      if (res && res.rcode === 0) {
        commit(SET_APP_CATEGORY_LIST, res.result.data)
        commit(SET_APP_CATEGORY_COUNT, res.result.count)
      }
      return res
    } catch (err) {
      return err
    }
  },
  async addAppCategory ({ commit }, data) {
    try {
      return await storeApi.addAppExtendParam(data)
    } catch (err) {
      return err
    }
  },
  async editAppCategory ({ commit }, data) {
    try {
      return await storeApi.editAppExtendParam(data)
    } catch (err) {
      return err
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/store.js